/* -------------------------------------------------------------------------- */
/*                        Schema Execution Routes                             */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const comment = new schema.Entity('comments', {}, { idAttribute: 'routeCommentId' });
export const comments = new schema.Array(comment);
